
import dialogShell from '@/components/common/dialog-shell/index.vue';
import { defineComponent, PropType } from 'vue';
import { FirmwareForm } from './all.type';

export default defineComponent({
    components: {
        dialogShell
    },
    props: {
        initForm: {
            type: Object as PropType<FirmwareForm>,
            required: true
        }
    }
});
